import { DeleteForever, ViewInAr } from "@mui/icons-material";
import {
  Box,
  Card,
  CardActions,
  CardContent,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";

export const reducer = (state, action) => {
  if (action.type === "LOAD_TEST_DATA") {
    return {
      ...state,
      labTest: { ...state.labTest, id: action.data },
    };
  } else if (action.type === "QUANTITY") {
    console.log("daa", state.id);
    return {
      ...state,
      quantity: { ...state.quantity, quantity: action.data },
      total:
        state.labTest.id === 57
          ? state.isZeroAmount
            ? 0.0
            : Number(state.amount)
          : Number(state.amount * action.data),
    };
  } else if (action.type === "CASTINGDATE") {
    return {
      ...state,
      castingDate: action.data,
    };
  } else if (action.type === "ZEROAMOUNT") {
    return {
      ...state,
      isZeroAmount: action.data,
      quantity: { ...state.quantity, quantity: 0 },
      total: 0.0,
    };
  } else if (action.type === "SERIALNO") {
    return {
      ...state,
      startingSerialNo: {
        ...state.startingSerialNo,
        startingSerialNo: action.data,
      },
    };
  } else if (action.type === "UPDATE_AMOUNT") {
    return {
      ...state,
      amount: action.data.amount,
      labTest: { ...state.labTest, labTestName: action.data.testName },
    };
  } else if (action.type === "REPORT_COLLECT_METHOD") {
    return {
      ...state,
      reportCollectMethod: {
        ...state.reportCollectMethod,
        reportCollectMethod: action.data,
      },
    };
  } else if (action.type === "SAMPLE_COLLECT_METHOD") {
    return {
      ...state,
      sampleCollectMethod: {
        ...state.sampleCollectMethod,
        sampleCollectMethod: action.data,
      },
    };
  } else if (action.type === "CHECK_ERROR") {
    return {
      ...state,
      labTest: {
        ...state.labTest,
        error: state.labTest.id ? false : true,
      },
      quantity: {
        ...state.quantity,
        error: state.quantity.quantity ? false : true,
      },
      startingSerialNo: {
        ...state.startingSerialNo,
        error: state.startingSerialNo.startingSerialNo ? false : true,
      },
      reportCollectMethod: {
        ...state.reportCollectMethod,
        error: state.reportCollectMethod.reportCollectMethod ? false : true,
      },
      sampleCollectMethod: {
        ...state.sampleCollectMethod,
        error: state.sampleCollectMethod.sampleCollectMethod ? false : true,
      },
    };
  } else if (action.type === "RESET") {
    return {
      labTest: { id: "", error: false, helperText: "" },
      quantity: { quantity: "", error: false, helperText: "" },
      amount: "",
      total: "",
      isZeroAmount: false,
      castingDate: "",
      sampleCollectMethod: {
        sampleCollectMethod: "",
        error: false,
        helperText: "",
      },
      reportCollectMethod: {
        reportCollectMethod: "",
        error: false,
        helperText: "",
      },
    };
  } else {
    return state;
  }
};

//Open dialog new job request
export const initialValues = {
  labTest: { id: "", labTestName: "", error: false, helperText: "" },
  quantity: { quantity: "", error: false, helperText: "" },
  startingSerialNo: { startingSerialNo: "", error: false },
  isZeroAmount: false,
  amount: "",
  total: "",
  castingDate: "",
  sampleCollectMethod: {
    sampleCollectMethod: "",
    error: false,
    helperText: "",
  },
  reportCollectMethod: {
    reportCollectMethod: "",
    error: false,
    helperText: "",
  },
};

//add tests component
export const AddTestDataToTable = ({
  labTestId,
  labTestName,
  reportCollectMethod,
  sampleCollectMethod,
  amount,
  quantity,
  startingSerialNo,
  total,
  colors,
  isNonMobile,
  year,
  id,
  update,
  handleRemoveSeleced,
  castingDate,
  autoIdByYear,
}) => {
  return (
    <Card
      variant="outlined"
      sx={{
        border: `${colors.greenAccent[500]} solid thin`,
        width: "100%",
        marginBottom: "6px",
        //   backgroundColor: colors.grey[900],
      }}
    >
      <CardContent style={{ paddingBottom: "2px" }}>
        <Box
          display="grid"
          gap="8px"
          gridTemplateColumns="repeat(4, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 4",
            },
          }}
        >
          <Box
            sx={{
              gridColumn: "span 5",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Box>
              <Typography variant="h3" color={colors.grey[500]}>
                {labTestName}
              </Typography>
            </Box>
          </Box>
          <Divider sx={{ gridColumn: "span 5" }} />
          <Box
            sx={{
              gridColumn: "span 1",
            }}
          >
            <Typography variant="h5">Report Collect Method</Typography>
            <Typography variant="h5" color="success">
              {reportCollectMethod}
            </Typography>
          </Box>
          <Box
            sx={{
              gridColumn: "span 1",
            }}
          >
            <Typography variant="h5">Sample Collect Method</Typography>
            <Typography variant="h5" color="success">
              {sampleCollectMethod}
            </Typography>
          </Box>
          <Box
            sx={{
              gridColumn: "span 1",
            }}
          >
            <Typography variant="h5">Price (Rs)</Typography>
            <Typography variant="h5" color="success">
              {amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
            </Typography>
          </Box>
          <Box
            sx={{
              gridColumn: "span 1",
            }}
          >
            <Typography variant="h5">Quantity</Typography>
            <Typography variant="h5" color="success">
              {quantity.toLocaleString(undefined, { minimumFractionDigits: 2 })}{" "}
              Nos
            </Typography>
          </Box>
          <Box
            sx={{
              gridColumn: "span 1",
            }}
          >
            <Typography variant="h3" color="success" fontWeight={550}>
              {total.toLocaleString(undefined, { minimumFractionDigits: 2 })}
            </Typography>
          </Box>
        </Box>
      </CardContent>
      <Divider />
      <CardActions
        sx={{
          margin: 0,
          paddingTop: "0px",
          paddingBottom: "0px",
          justifyContent: "space-between",
        }}
      >
        <Box display="flex" alignItems="center">
          <Typography variant="h5" color="error">
            {update === true
              ? "Job No : " + year + "/" + String(autoIdByYear).padStart(4, "0")
              : "Job No : Auto"}
          </Typography>
          <Typography variant="h5" color="info" marginLeft={2}>
            {"Starting Serial No : " + startingSerialNo}
          </Typography>
          {castingDate ? (
            <Box display="flex" gap={1} sx={{ marginLeft: "20px" }}>
              <ViewInAr color="info" />
              <Typography color="error" variant="h5">
                Casting Date : {castingDate}
              </Typography>
            </Box>
          ) : (
            ""
          )}
        </Box>
        <Box>
          <IconButton
            onClick={() => handleRemoveSeleced(labTestId, total)}
            color="error"
            aria-label="add an alarm"
          >
            <DeleteForever sx={{ fontSize: "25px" }} />
          </IconButton>
        </Box>
      </CardActions>
    </Card>
  );
};
